import authRequest from '../authRequest';

export default async function discardDocuments(sessionUuid) {
  if (!sessionUuid) {
    throw new Error('sessionUuid is required');
  }

  return authRequest(`/sessions/${sessionUuid}/discard_documents`, {
    method: 'DELETE',
  });
} 